export default {
  FORMS_CITY_LABEL: 'City',
  FORMS_DONOR_TYPE_OPTION_INDIVIDUAL: 'Individual',
  FORMS_DONOR_TYPE_OPTION_ORGANIZATION: 'Organization',
  FORMS_MIN_LABEL: 'Minimum',
  FORMS_MAX_LABEL: 'Maximum',
  FORMS_EIN_LABEL: 'Employer ID Number',
  FORMS_END_DATE_LABEL: 'End Date',
  FORMS_DATE_TYPE_LAST_MONTH: 'Last Month',
  FORMS_DATE_TYPE_LAST_6_MONTHS: 'Last 6 Months',
  FORMS_DATE_TYPE_LAST_12_MONTHS: 'Last 12 Months',
  FORMS_DATE_TYPE_CALENDAR_YTD: 'Calendar YTD',
  FORMS_DATE_TYPE_CUSTOM_DATES: 'Custom Dates',
  FORMS_HOURS_PLURAL_SUFFIX: ' hours',
  FORMS_HOURS_SINGULAR_SUFFIX: ' hour',
  FORMS_START_DATE_LABEL: 'Start Date',
  FORMS_ORG_PHONE_LABEL: 'Organization Phone Number',
  FORMS_TIME_PERIOD_LABEL: 'Time Period',
  FORMS_START_TIME_LABEL: 'Start Time',
  FORMS_START_TIME_REQUIRED: 'Start Time Required',
  FORMS_ADDRESS_LABEL: 'Address',
  FORMS_END_TIME_LABEL: 'End Time',
  FORMS_END_TIME_REQUIRED: 'End Time Required',
  FORMS_TOGGLE_NO_EIN: 'No EIN?',
  FORMS_TOGGLE_USE_EIN: 'Use EIN',
  FORMS_SORT_BY: 'Sort by',
  FORMS_SORT_A_Z: 'Name A-Z',
  FORMS_SORT_Z_A: 'Name Z-A',
  FORMS_STATE_LABEL: 'State',
  FORMS_VALIDATION_MIN_AMOUNT_INVALID:
    'The minimum contribution amount is higher than the maximum',
  FORMS_VALIDATION_MIN_TIME_INVALID:
    'The minimum hours are higher than the maximum',
  FORMS_VALIDATION_REQUIRED: 'Required Field',
  FORMS_VALIDATION_REQUIRED_LONG: 'This field cannot be left blank',
  FORMS_VALIDATION_FORMAT_EIN: 'Improper EIN Formatting',
  FORMS_VALIDATION_FORMAT_PHONE: 'Invalid Phone Number',
  FORMS_VALIDATION_EMAIL_REQUIRED: 'Email Required',
  FORMS_VALIDATION_NO_SPACES: 'This field cannot contain spaces',
  FORMS_VALIDATION_CAMEL:
    'Must be camelCased letters and/or numbers with no spaces.',
  FORMS_VALIDATION_MIN_ZERO: 'Must be greater than 0',
  FORMS_VALIDATION_WEBSITE: 'Must be a valid website url',
  LABELS_APPLIED_TO: 'Labels applied to',
  FORMS_POSTAL_CODE_LABEL: 'Zipcode',
  FORMS_BIRTHDATE: 'Birthdate',
  FORMS_BIRTHDATE_MONTH_LABEL: 'Birthday Month',
  FORMS_BIRTHDATE_BORN_AFTER_LABEL: 'Born After',
  FORMS_BIRTHDATE_BORN_BEFORE_LABEL: 'Born Before',
  FORMS_NAME_EMAIL_PHONE_LABEL: 'Name/Email/Phone',
  FORMS_COUNTRY_LABEL: 'Country',
  FORMS_CONSTITUENT_LABELS: 'Constituent Labels',
  FORMS_CONTRIBUTION_LABELS: 'Contribution Labels',
};
